export interface CreateCommunityCluster {
  cluster: {
    corporate_id: number;
    initiative_id: number;
    name: string;
    is_post_enabled: boolean;
    is_share_enabled: boolean;
    is_talk_enabled: boolean;
    is_visible: boolean;
  };
  owners: number[];
}

export interface ClusterData {
  id: number;
  corporate_id: number;
  initiative_id: number;
  name: string;
  is_post_enabled: boolean;
  is_share_enabled: boolean;
  is_talk_enabled: boolean;
  is_visible: boolean;
  drupal_id?: number;
}

export interface ClusterOwnerData {
  id_user: number;
  corporate_id: number;
  external_id: string;
  name?: string;
  surname?: string;
  email?: string;
  username: string;
}

export interface ClusterGroupData {
  id: number;
  name: string;
  corporate_id: number;
}

export interface ClusterInitiativeData {
  id: number;
  name: string;
}

export interface ClusterLearningObjectData {
  cluster_id: number;
  lo_id: number;
}

export interface GetClusterData {
  cluster: ClusterData;
  owners?: ClusterOwnerData[];
  groups?: ClusterGroupData[];
  initiatives?: ClusterInitiativeData[];
  learning_objects?: ClusterLearningObjectData[];
}

export interface ListGetClusterData {
  metadata: {
    total_pages: number;
    total_elements: number;
  };
  output: GetClusterData[];
}

export interface LinkClusterBody {
  initiatives?: number[];
  groups?: number[];
  learning_objects?: number[];
}

export interface ClusterUser {
  id: number;
  external_id: string;
  name?: string;
  surname?: string;
  email?: string;
  group_id?: number[];
  group_name?: string[];
}

export interface ListClusterUser {
  metadata: {
    total_pages: number;
    total_elements: number;
  };
  output: ClusterUser[];
}

export const checkAssociationChanged = (
  prev: Record<number, boolean>,
  cur: Record<number, boolean>,
): boolean => {
  const keysPrev = Object.keys(prev);
  const keysCur = Object.keys(cur);
  if (keysPrev.length === 0 && keysCur.length === 0) {
    return false;
  }
  if (keysPrev.length !== keysCur.length) {
    return true;
  }
  for (const key of keysPrev) {
    if (
      keysPrev[key as unknown as number] !== keysCur[key as unknown as number]
    ) {
      return true;
    }
  }
  return false;
};

export interface Discussions {
  enrichedInformation: EnrichedInformation;
  extendedInformation: ExtendedInformation;
  data: Discussion[];
  pager: Pager;
  count_data_obj: number;
}

export interface Discussion {
  comment_count: string;
  owner_id: string;
  created: string;
  publishDate: string;
  title: string;
  body: string;
  forum: Forum;
  langcode: string;
  subtitle: string;
  topic: Topic[];
  last_comment: string;
  id: string;
  changed: string;
  status: boolean;
}

export interface Forum {
  initiative: string;
  corporate: string;
  name: string;
  id: string;
}

export interface Topic {
  code: string;
  name: string;
}

export interface EnrichedInformation {
  los: any[];
  initiatives: EnrichedInformationInitiative[];
  users: User[];
}

export interface EnrichedInformationInitiative {
  initiativeName: string;
  initiative: string;
}

export interface User {
  corporateName: string;
  surname: string;
  owner_id: string;
  name: string;
  profileImageUrl: string;
  corporateId: string;
}

export interface ExtendedInformation {
  creationUser: number;
  persona: any[];
  externalEmployeeFlag: boolean;
  lastUpdateDate: number;
  roles: string[];
  externalId: string;
  newHireFlag: boolean;
  creationDate: number;
  uog: any[];
  corporateId: number;
  idUser: number;
  skills: any[];
  receievedCredentialsFlag: boolean;
  onboardingFlag: boolean;
  privacyConsentFlag: boolean;
  surname: string;
  name: string;
  smartWorkingFlag: boolean;
  lastUpdateUser: number;
  initiatives: ExtendedInformationInitiative[];
  adminFlag: boolean;
  email: string;
  status: number;
}

export interface ExtendedInformationInitiative {
  id: number;
  label: string;
}

export interface Pager {
  total_elements: number;
  total_pages: number;
  current_page: number;
  page_size: number;
}
